import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../../hooks/useTheme';
import { CardLayout } from './types';

interface LayoutToggleProps {
  layout: CardLayout;
  onLayoutChange: (layout: CardLayout) => void;
  showLabels?: boolean;
  compact?: boolean;
}

const LayoutToggle: React.FC<LayoutToggleProps> = ({
  layout,
  onLayoutChange,
  showLabels = true,
  compact = false,
}) => {
  const { colors } = useTheme();

  const handleToggle = () => {
    const newLayout = layout === 'horizontal' ? 'thumbnail' : 'horizontal';
    onLayoutChange(newLayout);
  };

  return (
    <TouchableOpacity
      style={[
        styles.container,
        { borderColor: colors.border },
        compact && styles.compact,
      ]}
      onPress={handleToggle}
      activeOpacity={0.7}
    >
      <Ionicons
        name={layout === 'horizontal' ? 'grid-outline' : 'list-outline'}
        size={compact ? 16 : 18}
        color={colors.primary}
      />
      {showLabels && (
        <Text style={[styles.label, { color: colors.primary }]}>
          {layout === 'horizontal' ? 'Thumbnails' : 'Vertical'}
        </Text>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: 'transparent',
    borderWidth: 1,
    gap: 6,
  },
  compact: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    gap: 4,
  },
  label: {
    fontSize: 13,
    fontWeight: '600',
  },
});

export default LayoutToggle;
